import { Component, OnInit } from '@angular/core';
import { ChargeInformationDto, ChargeInformationService, ChargeLoadTemplateGroupDto } from '@app/api/dmc';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputGroupComponent } from "@shared/components/input/input-group/input-group.component";
import { LabelDirective } from "@shared/components/input/label/label.directive";
import { SelectDirective } from "@shared/components/input/select/select.directive";
import { TranslatePipe } from "@ngx-translate/core";
import { InputDirective } from "@shared/components/input/input/input.directive";
import { FormApiService } from "@app/core/services/form-api.service";
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-chargeinformation-send-price',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    SelectDirective,
    TranslatePipe,
    InputDirective
  ],
  templateUrl: './chargeinformation-send-price.component.html',
  styleUrl: './chargeinformation-send-price.component.css'
})
export class ChargeinformationSendPriceComponent implements OnInit, HasUnsavedChanges {
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public chargeInformation?: ChargeInformationDto;
  public form: FormGroup = new FormGroup({
    chargeInformation: new FormControl(null, Validators.required),
    chargeLoadTemplateGroup: new FormControl(null, Validators.required),
    chargeLoadTemplateCarrier: new FormControl(),
    validFrom: new FormControl(null, Validators.required),
    validTo: new FormControl(null),
  });
  public templateGroups: ChargeLoadTemplateGroupDto[] = [];

  public templatePricesList: KeyValue[] = [];

  constructor(
    private readonly chargeInformationService: ChargeInformationService,
    private readonly formApiService: FormApiService,
  ) {

    this.chargeInformationService.chargeInformationGetChargeLoadTemplateGroupsGet().subscribe(result => {
      this.templateGroups = result;
      this.templatePricesList = this.templateGroups.map(el => ({ value: el.name, key: el.id })) as KeyValue[];
    });
  }

  public ngOnInit(): void {
    if (this.chargeInformation) {
      this.form.get('chargeInformation')?.patchValue(this.chargeInformation);
    }

    this.form.get('chargeLoadTemplateCarrier')?.valueChanges.subscribe(value => {
      const templateGroup = this.templateGroups.find(el => el.id === value);

      this.form.get('chargeLoadTemplateGroup')?.patchValue(templateGroup);
    })
  }

  public sendPrices(): void {
    if (this.form.valid) {
      const data = this.form.value;

      if (data.chargeLoadTemplateGroup && !data.chargeLoadTemplateGroup.chargeLoadTemplates) {
        data.chargeLoadTemplateGroup = {
          ...data.chargeLoadTemplateGroup,
          chargeLoadTemplates: []
        };
      }

      this.formApiService.submit(
        this.form,
        (data) => this.chargeInformationService.chargeInformationCreateChargeInformationPricesPost(data),
        {
          successMessage: 'chargeInformation.pricesSent',
          closeModal: true,
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }
}
